export default __webpack_public_path__ + "static/210602_夏日活動強更預告_en-beafc2a85dc3499373328d0b4390bf74.png";